<template>
    <div class="headline-big">
        <h4>{{ label }} </h4>
        <h3 class="light">{{ headline }} </h3>
    </div>
</template>

<script>
export default {
    props: {
        headline: String,
        label: String
    }
}
</script>

<style lang="scss">
    .headline-big {
        padding: 0.8rem 2.5rem;
        display: flex;
        flex-direction: row;
    }
</style>

<style lang="scss" scoped>
    h4 {
        margin-bottom: 5px;
    }
    h3 {
        font-size: 2.75rem;
        margin: -15rem 0 0 -1rem;
    }
</style>